<template>
  <div class="container p-0 h-100" style="overflow-y: auto;">
    <!-- Platforms list -->
    <div class="list-platforms">
      <h3 class="pt-3 pl-3 pb-2">
        <span v-if="!('embed' in this.$route.query)">
          Platforms <b-badge pill variant="primary">{{ platforms_count }}</b-badge>
        </span>
        <span v-else>
          <img src="/beluga-web/static/geomar_logo.png" alt="Logo" style="height: 35px" class="mr-1 mb-1">
        </span>
        <b-button class="btn float-right mr-3" variant="light" title="Maximize platforms list" @click="togglePlatformsBar"><font-awesome-icon :icon="['fas', 'angle-double-right']" /></b-button>
      </h3>
      <b-alert v-if="platforms_count === 0" show variant="warning" class="mt-2 ml-3 mr-3">
        <font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" /> No platforms associated with selected campaign.
      </b-alert>
      <div role="tablist" class="accordion">
        <b-card no-body v-for="platform in platforms" :key="platform.id" class="rounded-0 border-left-0 border-right-0">
          <b-card-header header-tag="header" class="collapse d-flex rounded-0 p-0 shadow-sm" role="tab">
            <platforms-list-header-widget :platform-id="platform.id" :full="false"></platforms-list-header-widget>
          </b-card-header>
          <b-collapse :id="'dashboard-' + platform.id" :visible="platform_visible(platform.id)" accordion="accordion-platforms" role="tabpanel">
            <b-card-body class="p-0">
              <b-card-text>
                <div v-if="typeof platform.last_change === 'undefined'">
                  <b-alert variant="info" show class="pl-3 pt-2 pb-2 m-3">
                    <font-awesome-icon :icon="['fas', 'spinner']" class="mr-1 fa-spin" size="sm" />
                    Waiting for data..
                  </b-alert>
                </div>
                <div v-else>
                  <auv-status-widget v-if="platform.type === 'auv-g500'" :platform-id="platform.id"></auv-status-widget>
                  <transponder-status-widget v-else-if="platform.type === 'transponder'" :platform-id="platform.id"></transponder-status-widget>
                  <ship-status-widget v-else-if="platform.type === 'ship'" :platform-id="platform.id"></ship-status-widget>
                  <ship-marine-traffic-status-widget v-else-if="platform.type === 'ship-mt'" :platform-id="platform.id"></ship-marine-traffic-status-widget>
                  <ship-d-ship-status-widget v-else-if="platform.type === 'ship-dship'" :platform-id="platform.id"></ship-d-ship-status-widget>
                  <ship-dagmar-aaen-status-widget v-else-if="platform.type === 'ship-dagmaraaen'" :platform-id="platform.id"></ship-dagmar-aaen-status-widget>
                  <ship-citizen-science-status-widget v-else-if="platform.type === 'ship-citizen-science'" :platform-id="platform.id"></ship-citizen-science-status-widget>
                  <ship-ocean-race-status-widget v-else-if="platform.type === 'ship-tor'" :platform-id="platform.id"></ship-ocean-race-status-widget>
                  <ship-iow-status-widget v-else-if="platform.type === 'ship-iow'" :platform-id="platform.id"></ship-iow-status-widget>
                  <saildrone-status-widget v-else-if="platform.type === 'saildrone'" :platform-id="platform.id"></saildrone-status-widget>
                  <waveglider-status-widget v-else-if="platform.type === 'waveglider'" :platform-id="platform.id"></waveglider-status-widget>
                  <logger-hyfive-status-widget v-else-if="platform.type === 'logger-hyfive'" :platform-id="platform.id"></logger-hyfive-status-widget>
                  <generic-status-widget v-else :platform-id="platform.id"></generic-status-widget>
                </div>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <div class="mt-2 text-secondary" v-if="platforms_count > 0 && this.selectedPlatform === 0" style="margin-left: 40px;">
        <font-awesome-icon :icon="['fas', 'angle-double-up']" class="mr-1" size="sm" />
        Select platform to open dashboard
      </div>
      <div v-else style="height: 41px;"></div>
    </div>
    <div class="footer pt-2 pb-2 pr-3 pl-3 border-top d-inline-flex justify-content-between" style="background-color: #f8f9fa;">
      <span class="text-muted">&copy; 2025 <strong>GEOMAR</strong> Kiel</span>
      <a href="https://www.geomar.de/en/impressum" target="_blank">
        <strong>Imprint</strong> <font-awesome-icon :icon="['fas', 'external-link-alt']" size="xs" class="align-baseline ml-1" />
      </a>
    </div>
<!--    <div class="sticky-bottom pt-2 pb-2 pr-3 pl-3 border-top d-inline-flex justify-content-between" style="background-color: rgba(0, 0, 0, 0.03);">-->
<!--      <span class="text-muted">&copy; 2021 <strong>GEOMAR</strong> Kiel</span>-->
<!--      <a href="https://www.geomar.de/en/impressum" target="_blank">-->
<!--        Imprint <font-awesome-icon :icon="['fas', 'external-link-alt']" size="xs" class="align-baseline ml-1" />-->
<!--      </a>-->
<!--    </div>-->
    <!-- Targets list -->
<!--    <div v-if="targets_count > 0 && targets_visible === true" class="list-targets">-->
<!--      <h3 class="pt-3 pl-3 pb-2">-->
<!--        AIS Targets <b-badge pill variant="primary">{{ targets_count }}</b-badge>-->
<!--      </h3>-->
<!--      <div role="tablist" class="accordion" style="overflow-y: auto; max-height: 150px;" >-->
<!--        <b-card no-body v-for="target in targets" :key="target.id" class="rounded-0 border-left-0 border-right-0">-->
<!--          <b-card-header style="display: table;" header-tag="header" class="collapse d-flex rounded-0 p-0 shadow-sm" role="tab">-->
<!--            <platforms-list-header-widget :platform-id="target.id" full="false"></platforms-list-header-widget>-->
<!--          </b-card-header>-->
<!--          <b-collapse :id="'dashboard-' + target.id" :visible="platform_visible(target.id)" accordion="accordion-targets" role="tabpanel">-->
<!--            <b-card-body class="p-0">-->
<!--              <b-card-text>-->
<!--                <generic-status-widget :platform-id="target.id"></generic-status-widget>-->
<!--              </b-card-text>-->
<!--            </b-card-body>-->
<!--          </b-collapse>-->
<!--        </b-card>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import Helpers from '@/mixins/helpers'
import PlatformsListHeaderWidget from '@/components/widgets/PlatformsListHeaderWidget'
import GenericStatusWidget from '@/components/widgets/generic/GenericStatusWidget'
import AuvStatusWidget from '@/components/widgets/auv/AuvStatusWidget'
import TransponderStatusWidget from '@/components/widgets/transponder/TransponderStatusWidget'
import ShipDShipStatusWidget from '@/components/widgets/ship/ShipDShipStatusWidget.vue'
import ShipStatusWidget from '@/components/widgets/ship/ShipStatusWidget'
import ShipDagmarAaenStatusWidget from '@/components/widgets/ship/ShipDagmarAaenStatusWidget.vue'
import ShipCitizenScienceStatusWidget from '@/components/widgets/ship/ShipCitizenScienceStatusWidget.vue'
import ShipOceanRaceStatusWidget from '@/components/widgets/ship/ShipOceanRaceStatusWidget.vue'
import ShipMarineTrafficStatusWidget from '@/components/widgets/ship/ShipMarineTrafficStatusWidget.vue'
import SaildroneStatusWidget from '@/components/widgets/saildrone/SaildroneStatusWidget'
import WavegliderStatusWidget from '@/components/widgets/waveglider/WavegliderStatusWidget'
import LoggerHyfiveStatusWidget from '@/components/widgets/loggers/LoggerHyfiveStatusWidget.vue'
import ShipIowStatusWidget from '@/components/widgets/ship/ShipIowStatusWidget.vue'

export default {
  name: 'PlatformsMinimizedWidget',
  mixins: [
    Helpers
  ],
  components: {
    ShipIowStatusWidget,
    LoggerHyfiveStatusWidget,
    ShipCitizenScienceStatusWidget,
    ShipDagmarAaenStatusWidget,
    ShipStatusWidget,
    ShipDShipStatusWidget,
    TransponderStatusWidget,
    AuvStatusWidget,
    ShipOceanRaceStatusWidget,
    SaildroneStatusWidget,
    WavegliderStatusWidget,
    GenericStatusWidget,
    PlatformsListHeaderWidget,
    ShipMarineTrafficStatusWidget
  },
  data: function () {
    return {}
  },
  methods: {
    ...mapMutations(['toggle_collapse']),
    togglePlatformsBar: function () {
      this.toggle_collapse('sidebar-platforms')
    },
    refreshViewport: function () {
      // this.$refs.map.refreshViewport()
      // this.$refs.watercolumn.refreshViewport()
    }
  },
  computed: {
    ...mapState(['selectedCampaign', 'selectedPlatform']),
    ...mapGetters(['campaignSelected', 'campaignPlatforms', 'countPlatforms']),
    platforms: function () {
      return this.$store.getters.campaignPlatforms(this.selectedCampaign)
    },
    platforms_count: function () {
      return this.campaignPlatforms(this.selectedCampaign).length
    },
    targets: function () {
      return this.$store.getters.targets
    },
    targets_count: function () {
      return this.$store.getters.countTargets
    },
    targets_visible: function () {
      return (this.$store.getters.campaignSelected.option_ais === '1')
    },
    platform_visible: function () {
      return (platformId) => {
        return Number(platformId) === Number(this.selectedPlatform)
      }
    },
    watercolumn_widget_width: function () {
      return this.platforms_count_watercolumn === 0 ? '70px' : 'calc(60px * ' + this.platforms_count_watercolumn + ')'
    },
    skip_entities: function () {
      return (platformType) => {
        switch (platformType) {
          case 'auv':
            return ['operation', 'navigation', 'safety', 'battery']
          default:
            return []
        }
      }
    },
    platforms_count_watercolumn () {
      // Only count platforms that can dive
      // TODO: Optimize
      let i = 0
      for (const platform in this.platforms) {
        if (Object.prototype.hasOwnProperty.call(this.platforms, platform)) {
          if (this.platforms[platform].type === 'auv' ||
            this.platforms[platform].type === 'transponder') {
            i = i + 1
          }
        }
      }
      return i
    }
  }
}
</script>

<style scoped>

.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}

</style>
